export default __webpack_public_path__ + "static/media/Hood of Haloga.dacc73f8.jpg";